import { Component } from "@kluntje/core";
import SSOService from "Services/SSOService";

/**
 * Custom Element to show CDC screens, Content based on users login state
 */
class FRAScreenset extends Component {
  SSOService = SSOService.getInstance();

  constructor() {
    super({
      props: {
        // name of gigya screenset. e.g "FRA-RegistrationLogin" for login
        screenSet: {
          type: "string",
          required: true,
        },
        startScreen: {
          type: "string",
          required: false,
        },
        // after user successfully logged in,
        // the page will be redirect to this URL via proxy page
        redirectUrl: {
          type: "string",
          required: false,
        },
        screenSetLang: {
          type: "string",
          required: false,
        },
        // after user successfully logged in,
        // the page will be redirect to this URL
        proxyPageUrl: {
          type: "string",
          required: false,
        },
      },
    });

    this.onAuthChange = this.onAuthChange.bind(this);
  }

  /**
   * @override
   */
  afterComponentRender() {
    // show screenset when it is login state independent
    if (this.screenSet) this.loadScreenset();
    // show screen/content depending on the login state
    this.SSOService.subscribe(this.onAuthChange);
  }

  // e.g. redirect to target page on login
  onAuthChange({ loggedIn }: { loggedIn: boolean }) {
    if (loggedIn) {
      // remove content
      this.replaceChildren();
      // on logged-in then redirect ot some other page which needs auth users
      if (this.proxyPageUrl) {
        location.href = this.SSOService.getProxyPageRedirectUrl(this.proxyPageUrl);
      }
      if (this.redirectUrl) {
        location.href = this.redirectUrl;
      }
    }
  }

  loadScreenset() {
    const screenContainer = this.getScreensetContainer();
    this.replaceChildren(screenContainer);
    this.SSOService.showScreenSet({
      containerID: screenContainer.id,
      screenSet: this.screenSet,
      screenSetLang: this.screenSetLang,
      startScreen: this.startScreen,
    });
  }

  // create new child with a unique ID for the gigya screen to be rendered in it
  private getScreensetContainer(): HTMLElement {
    const id = `fra-m-screenset__screen-container--${Math.random().toString(36).substring(2)}`;
    const container = document.createElement("div");
    container.id = id;
    return container;
  }
}

customElements.define("fra-m-screenset", FRAScreenset);

export default FRAScreenset;
